export const amountsinstorageConstants = {
  GET_AMOUNTSINSTORAGE_REQUEST: "GET_AMOUNTSINSTORAGE_REQUEST",
  GET_AMOUNTSINSTORAGE_SUCCESS: "GET_AMOUNTSINSTORAGE_SUCCESS",
  GET_AMOUNTSINSTORAGE_FAILURE: "GET_AMOUNTSINSTORAGE_FAILURE",
  CLEAR_AMOUNTSINSTORAGE: "CLEAR_AMOUNTSINSTORAGE",
};
